module.exports = __webpack_public_path__ + "img/9.985b2fe1.webp";